"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var hooks_1 = require("../../hooks");
var RelativeRouteContext_1 = __importDefault(require("../../contexts/RelativeRouteContext"));
var pathUtils_1 = require("../../helpers/pathUtils");
var resolvePath = function (currentUrl, routePath) {
    if (!routePath) {
        return currentUrl;
    }
    if (Array.isArray(routePath)) {
        return routePath.map(function (p) { return pathUtils_1.resolveRelativePath(currentUrl, p); });
    }
    return pathUtils_1.resolveRelativePath(currentUrl, routePath);
};
var RelativeRoute = function (props) {
    var path = props.path, routeProps = __rest(props, ["path"]);
    var url = hooks_1.useRouter().match.url;
    var resolvedPath = resolvePath(url, path);
    return (react_1.default.createElement(RelativeRouteContext_1.default.Provider, { value: { parentUrl: url } },
        react_1.default.createElement(react_router_dom_1.Route, __assign({ path: resolvedPath }, routeProps))));
};
exports.default = RelativeRoute;
